<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">我的投标</span>
    </template>
    <div v-loading="isLoading" class="bid-list">
      <template v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="bid-item-wrapper"
        >
          <bid-item
            :content-length="126"
            :value="item"
            :detail-btn-text="item.status === 1 && item.bidStatus ? '更新标书' : '查看详情'"
          >
            <template slot="footer">
              <span class="uploaded-bids ellipsis--l1">
                <a target="_blank" :href="item.userBidUrl">{{ item.userBidUrl }}</a>
              </span>
            </template>
          </bid-item>

          <!-- 流标 -->
          <img v-if="item.status === 4" class="icon-bidStatus" src="@/assets/images/icon-round-none.png">
          <template v-if="(item.status === 3 || item.status === 5) && item.bidStatus">
            <!-- 中标 -->
            <img v-if="item.providerId === user.id" class="icon-bidStatus" src="@/assets/images/icon-round-win.png">
            <!-- 未中标 -->
            <img v-else class="icon-bidStatus" src="@/assets/images/icon-round-lose.png">
          </template>
        </div>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :current-page="pagination.current"
          :page-size="pagination.size"
          :total="pagination.total"
          @current-change="pageChange"
        />
      </template>
      <empty-layout v-else />
    </div>
  </el-card>
</template>

<script>
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'

import { mapState } from 'vuex'
import { fetchMyBids } from '@/api'

const PAGE_SIZE = 5

export default {
  components: {
    BidItem,
    EmptyLayout
  },

  data() {
    return {
      list: [],

      pagination: {
        current: 1,
        size: PAGE_SIZE,
        total: 0
      },

      isLoading: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ])
  },

  mounted() {
    this.fetchBids()
  },

  methods: {
    fetchBids(page = 1) {
      this.isLoading = true

      fetchMyBids({
        pageSize: PAGE_SIZE,
        pageNo: page
      })
        .then(res => {
          const { records = [], total = 0 } = res.data

          this.list = records.map(val => val.projectInfoDo)
          this.pagination.total = total
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(res => {
          this.isLoading = false
        })
    },

    pageChange(page) {
      document.documentElement.scrollTop = 0
      this.fetchBids(page)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  padding-top: 0 !important;
}
.bid-list {
  .bid-item-wrapper {
    position: relative;
    .icon-bidStatus {
      position: absolute;
      top: 28px;
      right: 13px;
      z-index: 9;
    }
    .uploaded-bids {
      padding: 0 0 0 28px;
      line-height: 20px;
      background-image: url('~@/assets/images/icon-folder-blue.png');
      background-repeat: no-repeat;
      background-position: 0 0;
      color: #6C9CF9;
      margin: 0 0 0 38px;
    }
  }
  .el-pagination {
    display: table;
    margin: 20px auto 0;
  }
}
</style>
